interface CurrencyOption {
    label: string;
    value: string;
}

const defaultPriorityCurrencies = ['EUR', 'USD'];

export function sortCurrencies(a: CurrencyOption, b: CurrencyOption, customPriorityList: string[] = []): number {
    const combinedPriorityList = [...customPriorityList, ...defaultPriorityCurrencies];

    const aPriority = combinedPriorityList.indexOf(a.value);
    const bPriority = combinedPriorityList.indexOf(b.value);

    if (aPriority !== -1 && bPriority !== -1) {
        return aPriority - bPriority;
    }

    if (aPriority !== -1) return -1;
    if (bPriority !== -1) return 1;

    return 0;
}
